/* Muted/autoplay video pause-toggle used by the CLP hero
   (sections/clp-hero-banner.liquid). The same <script src> tag is emitted
   once per hero section, and since a duplicate customElements.define()
   throws, registration is guarded so pages rendering more than one hero
   don't hit a console error. */
(function () {
  if (customElements.get('celine-video-slot')) return;

  class CelineVideoSlot extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('[data-celine-video-toggle]');
      if (!this.video || !this.button) return;

      this.button.addEventListener('click', () => {
        if (this.video.paused) {
          this.video.play().catch(() => {});
        } else {
          this.video.pause();
        }
      });

      this.video.addEventListener('play', () => this.setPausedState(false));
      this.video.addEventListener('pause', () => this.setPausedState(true));
    }

    setPausedState(isPaused) {
      this.button.setAttribute('aria-label', isPaused ? this.dataset.playLabel : this.dataset.pauseLabel);
      this.classList.toggle('is-paused', isPaused);
    }
  }

  customElements.define('celine-video-slot', CelineVideoSlot);
})();
